import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = (response, index, context) => {
    context.competitorsUrls.splice(index, 1);
    if(context.competitorsUrls.length == 0){
        context.addNewUrlToCompetitorsObj();
    }
    context.get_rental_market_data(context.selectedRental);
    context.disabled = false;
    context.loading = false;
    toastr.success(response.msg);
    return response.data;
};

// When the request fails
const failed = (error, context) => {
    context.disabled = false;
    context.showToasterError(error);
};

export default (id, index, context) => {
    return Vue.$http.post('/rentals/delete-competitors-url', {'id': id})
        .then((response) => {
            if (response && response.status === 200) {
                success(response.data, index, context);
            } else {
                failed();
            }
    }).catch((error) => {
        failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/deleteCompetitorUrl.js